import { cn } from "@core-ui/utils/cn";
import { Skeleton } from "@ui-kit/Skeleton";

interface DropdownMenuSkeletonItemProps {
	labelClassName?: string;
}

export const DropdownMenuSkeletonItem = ({ labelClassName }: DropdownMenuSkeletonItemProps) => (
	<div className="flex h-8 items-center gap-2 px-2" data-testid="dropdown-menu-skeleton-item" role="progressbar">
		<Skeleton className="size-4 shrink-0 rounded" />
		<Skeleton className={cn("h-3.5 w-32 rounded", labelClassName)} />
	</div>
);
